module.exports = __webpack_public_path__ + "4ce4746ce2df3d1744e3bb07463a088f.svg";